import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DOCUMENT_TYPE_CONFIG } from "./apiRoutes";

interface UseGetDocTypeListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getDocumentTypeList = async (data: any) =>
  await axiosAuth.post(`${DOCUMENT_TYPE_CONFIG}/grid`, data);

const useGetDocumentTypeList = ({
  data,
  queryParams,
}: UseGetDocTypeListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["document-type"],
    queryFn: () => getDocumentTypeList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetDocumentTypeList;
